import { render } from "./FiltersSettings.vue?vue&type=template&id=0a428244&scoped=true"
import script from "./FiltersSettings.vue?vue&type=script&lang=js"
export * from "./FiltersSettings.vue?vue&type=script&lang=js"

import "./FiltersSettings.vue?vue&type=style&index=0&id=0a428244&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a428244"]])

export default __exports__